import {
  DocumentUploadRequest,
  DocumentUploadResponse,
} from "../contracts/Document";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { postDataAsync } from "../ZeosApiExecutor";
import { IDocument } from "./interfaces/IDocument";

let documentPrefix = "/Document/";

function buildSingleForm(data: DocumentUploadRequest): FormData {
  const fd = new FormData();
  fd.append("EntityTypeId", String(data.entityTypeId));
  fd.append("EntityId", String(data.entityId));
  fd.append("DocumentTypeId", String(data.documentTypeId));
  fd.append("DocumentCategoryId", String(data.documentCategoryId));
  fd.append("File", data.file);
  return fd;
}

function buildBatchForm(items: DocumentUploadRequest[]): FormData {
  const fd = new FormData();
  for (let i = 0; i < items.length; i++) {
    const x = items[i];
    fd.append(`requests[${i}].EntityTypeId`, String(x.entityTypeId));
    fd.append(`requests[${i}].EntityId`, String(x.entityId));
    fd.append(`requests[${i}].DocumentTypeId`, String(x.documentTypeId));
    fd.append(
      `requests[${i}].DocumentCategoryId`,
      String(x.documentCategoryId)
    );
    fd.append(`requests[${i}].File`, x.file);
  }
  return fd;
}

export const Document: IDocument = {
  createAsync: async (
    data: DocumentUploadRequest
  ): Promise<IZeosApiResponse<DocumentUploadResponse>> => {
    const form = buildSingleForm(data);
    return await postDataAsync<DocumentUploadResponse>(
      `${documentPrefix}create`,
      form,
      true
    );
  },

  createMultipleAsync: async (
    data: DocumentUploadRequest[]
  ): Promise<IZeosApiResponse<DocumentUploadResponse[]>> => {
    const form = buildBatchForm(data);
    return await postDataAsync<DocumentUploadResponse[]>(
      `${documentPrefix}create-multiple`,
      form,
      true
    );
  },
};
